var render = function render(){var _vm=this,_c=_vm._self._c;return _c('case-detail-base',{attrs:{"case-data":_vm.caseData}})
}
var staticRenderFns = []

export { render, staticRenderFns }